<template>
  <q-page style="">
        <div class="row justify-center" style="margin: auto; height: calc(100vh - 128px);">
            <div class="col-12 col-md-9 q-pa-lg" style="height: 100%;">
                <q-card  style="border-radius: 1rem !important; box-shadow: none !important; height: 100%; background: #fff; position: relative; width: 100%;"> 
                    <q-card-section style=" margin: 0;position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);  width: 100%;">
                    <div class="row justify-center q-pa-md" style="margin-top: auto; margin-bottom: auto;">
                        <div class="col-xs-12 col-sm-5 col-md-6 col-lg-5 q-py-md q-px-sm text-center">
                            <img  src="@/assets/maintenance.png" style="height: auto; width: 100%; max-height: 450px !important;" >
                        </div>
                        <div class="col-xs-12 col-sm-7 col-md-6 col-lg-5 q-py-md q-px-sm" style="padding-left:20px">
                            <div class="text-bold q-mb-xs" style="font-size: 24px !important;">Oops! </div>
                            
                            <div class="text-bold q-mb-xs" style="font-size: 16px !important;">The system is currently under maintenance.
                             </div>
                                <div>
                                We are working on it, and appreciate your patience.
                            </div>
                            <br>
                            <q-btn unelevated style="background: #ff6666; color: white; border-radius: 0.5rem;"  label="Contact Us" @click="reroute()" ></q-btn>
                        </div>
                    </div>
                    </q-card-section>
                </q-card>

               <!--  <q-card  style="height: 50vh; "> 
                    <div class="row justify-center" >
                        <div class="column justify-center">
                            <div class="col-3 column self-center">
                               
                            </div>
                        </div>  
                         <div class="column justify-center">
                            <div class="col column self-center">
                                <div class="text-h4 bold text-weight-medium" style="color:blue;">Oops! </div>
                                </br>
                                <div class="text-h4 bold text-weight-medium" style="color:blue;">The system is under maintenance.</div>
                                </br>
                                <div class="text-h4 bold text-weight-medium" style="color:blue;">We are working on it, and appreciate your patience</div>
                                 
                            </div>
                        </div>  
                    </div>
                </q-card> -->
                

               <!-- 
                   <div>Icons made by <a href="https://www.flaticon.com/authors/eucalyp" title="Eucalyp">Eucalyp</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
                   
                    <q-card style="height: 50vh; "> 
                    <div class="row justify-center" >
                        <div class="column justify-center">
                            <div class="col-3 column self-center">
                                <img  src="@/assets/img/maintenance.png" style="height:150px">
                            </div>
                        </div>                      
                    </div> 
                    </br>
                    <div class="row justify-center" style="padding-top:30px">
                        <div class="column justify-center">
                            <div class="col-3 column self-center">
                                <div class="text-h4 bold text-weight-medium" style="color:blue;">{{$t("common.maintenancepage")}}</div>
                            </div>
                        </div>  
                    </div>          
                </q-card>  -->
            </div>
        </div>
  </q-page>
</template>

<script>
export default {
      data() {},  
    methods:{
      reroute:function(){
        window.location.href = 'https://affinhwangam.com/get-in-touch/contact-us'
    }

    },mounted(){
        this.$q.loading.hide()
       var url = new URL(window.location.href);
        var url_string = url.search;

       this.$store.dispatch('Logging',{
            appid : '2',
            typeid :'4', 
            str : 'MAINTENANCE PAGE --> ' + url_string
        });
  }
 
}
</script>